export function StudentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12.486 4.126a1 1 0 00-.972 0l-8.982 4.99A1.001 1.001 0 002 10v7a1 1 0 102 0v-5.3l3 1.666v3.682c0 1.38 2.239 3 5 3s5-1.62 5-3v-3.682l4.486-2.492a1 1 0 000-1.748l-9-5zM12 13.856L5.06 10 12 6.144 18.94 10 12 13.856z"
      ></path>
    </svg>
  );
}
